import { ThemeProvider, themes } from '@/styles/styled'
import GlobalStyle from '@/styles/global'
import { useAppSelector } from '../hooks'

const Theme = ({ children }: { children: React.ReactNode }) => {
  const { theme } = useAppSelector((state) => state.theme)

  return (
    <ThemeProvider theme={themes[theme]}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}

export default Theme
